import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import { store } from './app/store'
import App from './App'
import './index.scss'
import reportWebVitals from './reportWebVitals';

// Bootstrap components
import 'bootstrap/dist/css/bootstrap.min.css';

import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import { MyAuthProvider } from './MsalProvider'


if (process.env.NODE_ENV === 'production') {
    disableReactDevTools();
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <Provider store={store}>
            <Router>
                <MyAuthProvider>
                    <App />
                </MyAuthProvider>
            </Router>
        </Provider>
    </React.StrictMode>
)


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
